import React, { useState, useEffect } from "react";
import { PaymentElement } from "@stripe/react-stripe-js";
// import { useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { Elements,CardElement } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ToastContainer, toast } from "react-toastify";

import { post } from "../network/api";

const PaymentFormSubscription = ({ price,
  name,email,
  handleSuccessCallback, handleErrorCallback }) => {
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    setStripePromise(
      loadStripe(
        process.env.REACT_APP_STRIPE_KEY
      )
    );
  }, []);

  useEffect(() => {
    console.log(price);
    post("customer/create-subs-intent", {
      price_id:  
      price ?? 100,
      name: name,
      email: email,
    }).then(async (data) => {
      setClientSecret(data);
    });
  }, []);

  return (
    <>
      {/* <h1>React Stripe and the Payment Element</h1> */}
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CheckoutForm

                  clientSecret={clientSecret}

            handleErrorCallback={handleErrorCallback}
            handleSuccessCallback={handleSuccessCallback}
          />
        </Elements>
      )}
    </>
  );
};

export default PaymentFormSubscription;

function CheckoutForm({ clientSecret , handleSuccessCallback, handleErrorCallback }) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);

    
    const cardElement = elements.getElement(CardElement);

    const { setupIntent , error } = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          // name: "Fateh Singh",
        }
      }
    });

    if (setupIntent) {
      // handle payment back
      handleSuccessCallback(setupIntent);
    } else if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);
      } else {
        setMessage("An unexpected error occured. ");
        handleErrorCallback(error);
      }
    } else {
      console.log(setupIntent, "Console log");
      console.log(error);
    }

    setIsProcessing(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}
      className="bg-white p-4 rounded shadow"

    >
      <CardElement />
      <button disabled={isProcessing || !stripe || !elements} id="submit">
        <span id="button-text">
          {isProcessing ? "Processing ... " : "Subscribe"}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}
